import {connect} from 'react-redux';
import React from 'react';

import Header from './common/Header';
import Link from '../../../elements/Link';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import Screen from '../../Screen';

class MyProfileScreen_Delete extends React.Component {
    render() {
        let {i18n} = this.props;

        return <Screen header={<Header {
                ...this.props
            } />}>
            <div className="content">
                <br/>
                <p className="text">{i18n['label.delete.typeofdata']}</p>
                <br/>
            </div>
            {
                this.props.hasEvents
                    ? <Link href="./event">
                            <ListItem tagName="div" icon="/img/calendar_icon.png" iconColor="#19b0c6" iconSmall="iconSmall" next="next">
                                <p className="text main">{i18n['label.event']}</p>
                                <p className="text">{i18n['label.delete-options-info.event']}</p>
                            </ListItem>
                        </Link>
                    : null
            }
            {
                this.props.hasCommunities
                    ? <Link href="./community">
                            <ListItem tagName="div" icon="/img/community.png" iconColor="#19b0c6" iconSmall="iconSmall" next="next">
                                <p className="text main">{i18n['label.community']}</p>
                                <p className="text">{i18n['label.delete-options-info.community']}</p>
                            </ListItem>
                        </Link>
                    : null
            }
            <Link href="./networkapp">
                <ListItem tagName="div" icon="/img/myNetworkApp.png" iconColor="#19b0c6" iconSmall="iconSmall" next="next">
                    <p className="text main">{i18n['label.delete.newtwork.data']}</p>
                    <p className="text">{i18n['label.delete-options-info.networkapp']}</p>
                </ListItem>
            </Link>
        </Screen>;
    }
}

const ConnectedScreenComponent = connect((state, props) => {
    return {
        i18n: state.i18n.translations,
        hasEvents: !!state
            .events
            .loadedEvents
            .map(id => state.events[id].event)
            .filter(event => event._isEvent)
            .length,
        hasCommunities: !!state
            .events
            .loadedEvents
            .map(id => state.events[id].event)
            .filter(event => event._isCommunity)
            .length
    };
})(MyProfileScreen_Delete);

export default props => <ConnectedScreenComponent {...props.match.params} />
